import styled from 'styled-components';

import { Text } from '@/nova/components/Text/Text';
import { COLORS, SPACE } from '@/nova/theme/tokens';

/* The Mini-games library draws on the shared ad library shell (grid, cards, archived sheet); these are the shell
   pieces it paints its not-generated card poster with (the game at rest over its plate is `GamePoster`), plus the
   card's hosted-embed stats row (above the shared tracking-link figures, `AssetStats/AssetCardStats`). */

export { PosterEmpty, PosterPlaceholder } from '../AdLibraryShell/AdLibraryShell.styles';

/** A card's hosted-embed counters over the last 30 days, one cell each, under a hairline. */
export const StatsRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: ${SPACE[4]};
  padding-top: ${SPACE[8]};
  border-top: 1px solid ${COLORS.hairline};
`;

export const Stat = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[2]};
  min-width: 0;
`;

export const StatValue = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  color: ${COLORS.text};
`;

export const StatLabel = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 11px;
  color: ${COLORS.textFaint};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

/** The short wait while a new mini-game's draft is minted (before the composer opens on the game picker). */
export const Minting = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${SPACE[12]};
`;

export const MintingText = styled(Text).attrs({ tag: 'span' as const })`
  font-size: 13px;
  color: ${COLORS.textMuted};
`;
